import React from 'react';
import UpdateProfileForm from './forms/UpdateProfileForm';
import styles from './modals.styl';
const UpdateProfileModal = ({ t, ...props }) => {
    // useEffect(() => {
    //   console.log('hotjar UPDATE_PROFILE_MODAL = ', hotjar);
    //   hotjar.event('UPDATE_PROFILE_MODAL');
    // }, []);  // eslint-disable-line
    return (React.createElement("div", { className: styles.modal },
        React.createElement("div", { className: styles.LoginRegistrationModal },
            React.createElement("div", { className: styles.contentUpdate },
                React.createElement("h4", { className: styles.heading }, t('modals:offerRequest.registrationTitle')),
                React.createElement(UpdateProfileForm, { t: t, ...props })))));
};
export default UpdateProfileModal;
